/* Bridges the landing page's add-to-cart links to the storefront's flyout cart.

   The links stay real links to /cart/add. If the theme's cart scripts are not
   present, or the variant cannot be read off the href, or the add fails, the
   click is left alone and the browser navigates to the normal cart page. The
   flyout is an enhancement, never a dependency. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var links = document.querySelectorAll('a[data-cart-hook="add-to-cart"]');

    Array.prototype.forEach.call(links, function (el) {
      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href') || '';
        var id = href.match(/[?&]id=(\d+)/);
        var qty = href.match(/[?&]quantity=(\d+)/);
        var plan = href.match(/[?&]selling_plan=(\d+)/);

        /* Nothing to intercept with -- let the link be a link. */
        if (!id) return;
        if (typeof addProduct !== 'function' || typeof openCart !== 'function') return;

        e.preventDefault();
        if (el.getAttribute('data-busy')) return;

        var label = el.textContent;
        el.setAttribute('data-busy', '1');
        el.setAttribute('aria-busy', 'true');
        el.textContent = 'Adding…';

        function restore() {
          el.textContent = label;
          el.removeAttribute('data-busy');
          el.removeAttribute('aria-busy');
        }

        var item = { id: parseInt(id[1], 10), quantity: qty ? parseInt(qty[1], 10) : 1 };
        /* A subscription line is the same variant plus a selling plan. Drop the
           plan and Shopify adds a full-price one-off instead. */
        if (plan) item.selling_plan = parseInt(plan[1], 10);

        addProduct({ items: [item] })
          .then(function () { return openCart(); })
          .then(restore)
          .catch(function () {
            /* The add did not land. Send them to the cart page rather than
               leaving a button that looks like it did nothing. */
            restore();
            window.location.href = href;
          });
      });
    });
  });
}());
